import React from "react";
import { CheckCircle, AlertCircle, AlertTriangle, Info, X } from "lucide-react";

export const ToastIcons = {
  success: (
    <CheckCircle className="h-5 w-5 text-green-600 dark:text-green-400" />
  ),
  error: <AlertCircle className="h-5 w-5 text-destructive" />,
  warning: (
    <AlertTriangle className="h-5 w-5 text-amber-500 dark:text-amber-400" />
  ),
  info: <Info className="h-5 w-5 text-primary" />,
  error_x: <X className="h-5 w-5 text-destructive" />,
};
